import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const STORAGE_KEY = "FEATURE_FLAGS_STORE";

type FeatureFlagsStore = {
  flags: Record<string, boolean>;
  setFlag: (key: string, value: boolean) => void;
};

export const useFeatureFlagsStore = create<FeatureFlagsStore>()(
  persist(
    (set) => ({
      flags: {},
      setFlag: (key, value) =>
        set((state) => ({ flags: { ...state.flags, [key]: value } })),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
